import { notFound, permanentRedirect } from 'next/navigation';

import { adjustPathname } from '@monoimin/utils/helpers';

import { getLocalePrefix } from '@monoimin/intl';

import { getStrapiEstateBySlug } from './getStrapiEstateBySlug';

import type { EnOrRuLocale, LocalizedSlugPageProps } from '@monoimin/sb-types';

export const getEstatePageData = async (
  params: Awaited<
    LocalizedSlugPageProps<string[], object, EnOrRuLocale>['params']
  >,
  isPreview: boolean
) => {
  const { slug, locale } = params;
  if (!Array.isArray(slug) || slug.length !== 2) {
    notFound();
  }

  const localePrefix = getLocalePrefix(locale);

  const [countrySlug, estateSlug] = slug;
  const lowerSlug = estateSlug.toLowerCase();
  if (estateSlug !== lowerSlug) {
    permanentRedirect(
      adjustPathname(`${localePrefix}/real-estate/${countrySlug}/${lowerSlug}`)
    );
  }
  const estate = await getStrapiEstateBySlug({
    slug: lowerSlug,
    locale: locale,
    isDraft: isPreview,
    countrySlug,
  });

  if (!estate) {
    permanentRedirect(
      adjustPathname(`${localePrefix}/real-estate/${countrySlug}`)
    );
  }

  return estate;
};

export default getEstatePageData;
